import React from 'react';
export function TransicionSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-156">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-157">
        <div className="space-y-4 text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-158">
          <p data-id="element-159">Este mapa te muestra tus fugas.</p>
          <br data-id="element-160" />
          <p data-id="element-161">
            El siguiente paso es cerrarlas — y rediseñar tu negocio alrededor
            del 20% que sí genera crecimiento.
          </p>
          <br data-id="element-162" />
          <p data-id="element-163">Eso es lo que hacemos juntas en:</p>
        </div>

        <div className="mt-12 space-y-4" data-id="element-164">
          <p className="text-4xl md:text-5xl font-extrabold tracking-tight" data-id="element-165">
            <span className="text-[#1B2A4A]" data-id="element-166">JUEGA DESDE </span>
            <span className="text-[#D90B10]" data-id="element-167">OTRO NIVEL</span>
          </p>
          <p className="text-lg md:text-xl text-gray-600" data-id="element-168">
            El primer sistema para vender sin fugas.
          </p>
        </div>

        <div className="mt-8 space-y-4" data-id="element-169">
          <a href="#formulario" onClick={e => {
          e.preventDefault();
          document.getElementById('formulario')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-block bg-[#D90B10] hover:bg-[#c00a0e] text-white font-bold py-4 px-10 rounded-lg text-lg transition-colors shadow-lg" data-id="element-170">
            Conócelo aquí →
          </a>
          <p className="text-sm text-gray-500" data-id="element-171">
            Luego de dejas tus datos en el formulario para descargar tu mapa
          </p>
        </div>
      </div>
    </section>;
}